import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router"
import { Route } from '../../interfaces/route';
import { RouteService } from '../../services/route.service';
import { StatusService } from '../../services/status.service';

@Component({
  selector: 'app-route-selection',
  templateUrl: './route-selection.component.html',
  styleUrls: ['./route-selection.component.css']
})

export class RouteSelectionComponent implements OnInit {
  selectLimit: number = 3;
  routes: Route[];
  selectedRoutes: Route[] = [];
  statuses: Route[] = [];

  constructor(private statusService: StatusService, private routeService: RouteService, private router: Router) {
    this.selectedRoutes = this.routeService.selected;
   }

  ngOnInit(): void {
    this.getRoutes();
    this.selectedRoutes = this.routeService.selected;
    this.routeService.cast.subscribe(user=> this.selectedRoutes = user);
  }

  getRoutes(): void {
    this.statusService.get()
        .subscribe(statuses => this.statuses = statuses);
  }

  onSelect(route: Route): void {
    var index: number = this.selectedRoutes.indexOf(route);

    if(this.selectLimit <= this.selectedRoutes.length && index === -1){
      this.selectedRoutes.pop();
    }

    if(index === -1){
      this.selectedRoutes.push(route);
    }
    else{
      this.selectedRoutes.splice(index, 1);
    }

    this.routeService.select(this.selectedRoutes);
  }

  onRemove(route: Route): void{
    this.selectedRoutes.splice(this.selectedRoutes.indexOf(route), 1);
  }

  onDetail(route: Route): void{
    this.routeService.detail(route);
    this.router.navigate(['/routes/status'])
  }
}
